module.exports = __webpack_public_path__ + "static/mieszkania-na-sprzedaz-puck-tablet-cb23117dcffe728ca11f44644ffc2208.jpg";